<template>
  <div class="navbar" :class="{ 'is-ipad': isIpad }">
    <div class="hamburger-container">
      <el-select
        v-if="userStore.isAdmin()"
        v-model="pharmacy"
        placeholder="请选择门店"
        style="min-width: 180px"
        @change="selectChangeFn"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-row v-else style="margin-left: 12px; margin-top: 2px">
        {{ pharmacyName }}
      </el-row>
    </div>

    <div class="right-menu">
      <div class="right-menu-btn">
        <PopoverBox width="230" placement="bottom">
          <template #conent>
            <div class="pointer">
              <SvgIcon
                style="transform: translateY(1px)"
                svgId="#icon-line40"
                class="icon-play"
              ></SvgIcon>
              <span style="white-space: nowrap">客服</span>
            </div>
          </template>
          <template #popConent>
            <div class="customer-box">
              <el-row>
                <el-image :src="guwenInfo.introduce">
                  <template #error>
                    <el-empty description="暂无二维码" :image-size="100" />
                  </template>
                </el-image>
              </el-row>
              <el-row class="text greeary" style="margin-top: 0">
                扫码添加技术顾问
              </el-row>
              <el-row class="text saoma">
                您的技术顾问：{{ guwenInfo.nickname ?? '-' }}
              </el-row>
              <el-row class="text">
                联系电话：{{ guwenInfo.mobile ?? '-' }}
              </el-row>
              <el-row class="text" v-if="guwenInfo.field">
                联系电话：{{ guwenInfo.field ?? '-' }}
              </el-row>
              <el-row class="text"> 工作时间：08:40-17:40 </el-row>
            </div>
          </template>
        </PopoverBox>

        <div
          ref="moreToolsPanelRef"
          v-show="!isIpad || moreToolsVisible"
          class="responsive-tools"
          :class="{ 'is-ipad': isIpad }"
          @click.stop
        >
          <PopoverBox width="640">
            <template #conent>
              <div class="pointer">
                <SvgIcon svgId="#icon-zhuti-04" class="icon-play"></SvgIcon>
                <span style="white-space: nowrap">主题</span>
              </div>
            </template>
            <template #popConent>
              <div class="appearance-panel theme-panel">
                <div class="appearance-panel-header">
                  <span>更换皮肤</span>
                  <span class="current-theme-dot"></span>
                </div>
                <div class="theme-options">
                  <button
                    v-for="item in themeOptions"
                    :key="item.value"
                    type="button"
                    class="theme-option"
                    :class="{ 'is-active': theme == item.value }"
                    :style="{ backgroundColor: item.preview }"
                    :title="item.label"
                    :aria-label="`切换为${item.label}`"
                    :aria-pressed="theme == item.value"
                    @click="changeColorFn(item.value)"
                  >
                    <el-icon v-if="theme == item.value" class="theme-check">
                      <Check />
                    </el-icon>
                  </button>
                </div>
              </div>
            </template>
          </PopoverBox>
          <PopoverBox width="380">
            <template #conent>
              <div class="pointer">
                <SvgIcon svgId="#icon-zihao" class="icon-play"></SvgIcon>
                <span style="white-space: nowrap">字号</span>
              </div>
            </template>
            <template #popConent>
              <div class="appearance-panel font-panel">
                <div class="appearance-panel-header">
                  <span>调整字号</span>
                  <span class="font-panel-hint">选择适合你的阅读大小</span>
                </div>
                <div class="font-size-options">
                  <button
                    v-for="item in fontSizeOptions"
                    :key="item.value"
                    type="button"
                    class="font-size-option"
                    :class="{ 'is-active': appStore.getSize == item.value }"
                    :aria-pressed="appStore.getSize == item.value"
                    @click="changeTextSizeFn(item.value)"
                  >
                    <span
                      class="font-size-preview"
                      :style="{ fontSize: item.previewSize }"
                      >Aa</span
                    >
                    <span class="font-size-label">{{ item.label }}</span>
                  </button>
                </div>
              </div>
            </template>
          </PopoverBox>
          <PopoverBox
            ref="learnNoticePopRef"
            width="700"
            @show="initLearnNotice"
          >
            <template #conent>
              <div class="pointer">
                <SvgIcon svgId="#icon-tishi" class="icon-play"></SvgIcon>
                <span style="white-space: nowrap">学习公示</span>
              </div>
            </template>
            <template #popConent>
              <div class="learn-notice-box">
                <div class="learn-notice-header">公示信息</div>
                <div class="learn-notice-form">
                  <div class="learn-notice-form-item">
                    <span class="learn-notice-label">开始时间</span>
                    <el-date-picker
                      v-model="learnNoticeStartTime"
                      type="date"
                      placeholder="选择开始时间"
                      format="YYYY年M月D日"
                      value-format="YYYY-MM-DD"
                      :teleported="false"
                      @change="handleLearnNoticeStartTimeChange"
                    />
                  </div>
                  <div class="learn-notice-form-item">
                    <span class="learn-notice-label">结束时间</span>
                    <el-date-picker
                      v-model="learnNoticeEndTime"
                      type="date"
                      placeholder="选择结束时间"
                      format="YYYY年M月D日"
                      value-format="YYYY-MM-DD"
                      :teleported="false"
                    />
                  </div>
                  <div class="learn-notice-form-item">
                    <span class="learn-notice-label">提前公示</span>
                    <el-select
                      v-model="learnNoticeAdvanceDays"
                      class="learn-notice-days-select"
                      :teleported="false"
                      @change="handleLearnNoticeAdvanceDaysChange"
                    >
                      <el-option
                        v-for="item in learnNoticeAdvanceDayOptions"
                        :key="item"
                        :label="`${item}天`"
                        :value="item"
                      />
                    </el-select>
                  </div>
                  <el-checkbox v-model="learnNoticeSyncPatient">
                    公示内容是否在患者端(公众号)显示
                  </el-checkbox>
                </div>
                <div class="learn-notice-header">公示内容</div>
                <WangEditor
                  ref="learnNoticeEditorRef"
                  v-model="learnNoticeContent"
                  editorId="learnNoticeEditor"
                  :height="isMaxIpad ? '150px' : '300px'"
                />
                <div class="learn-notice-footer">
                  <el-button
                    type="primary"
                    @click="saveLearnNotice"
                    :loading="saving"
                    >保存</el-button
                  >
                  <el-button type="primary" @click="printLearnNotice"
                    >打印</el-button
                  >
                </div>
              </div>
            </template>
          </PopoverBox>
        </div>
        <PopoverBox
          ref="popoverMsgRef"
          width="300"
          :popper-style="{ 'padding': '0' }"
          @show="initMsgList"
        >
          <template #conent>
            <div class="pointer">
              <SvgIcon svgId="#icon-xiaoxi" class="icon-play"></SvgIcon>
              <span style="white-space: nowrap">
                消息
                <el-badge class="mark" :value="msgCount" :show-zero="false" />
              </span>
            </div>
          </template>
          <template #popConent>
            <div class="message-box">
              <el-row class="header">
                <span>消息通知</span>
                <el-link type="primary" underline="never" @click="checkAllFn">
                  全部已读
                </el-link>
              </el-row>
              <div class="body">
                <el-row
                  class="body-item"
                  :class="{ 'is-check': item.readStatus }"
                  v-for="item in messageList"
                  @click="jumpMsgDetail(item)"
                >
                  <div class="item-image">
                    <div class="msg-icon-play">
                      <i class="font_family icon-tongzhi"></i>
                    </div>
                  </div>
                  <div class="item-content">
                    <el-row class="item-title ellipsis-text">
                      <span class="ellipsis-text">{{ item.title }}</span>
                    </el-row>
                    <div>{{ custFormatDate(item.createTime) }}</div>
                  </div>
                </el-row>
              </div>
            </div>
          </template>
        </PopoverBox>
        <div
          v-if="isIpad"
          ref="moreToolsTriggerRef"
          class="pointer more-tools-trigger"
          @click.stop="moreToolsVisible = !moreToolsVisible"
        >
          <span>更多</span>
          <el-icon class="more-tools-arrow"><ArrowDown /></el-icon>
        </div>
      </div>
      <PersonalCenter style="line-height: 50px; margin-left: 20px" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import PersonalCenter from './PersonalCenter.vue'
import PopoverBox from '@/components/PopoverBox/index.vue'
import WangEditor from '@/components/Editor/wangeEditor.vue'
import {
  getLearnNotice,
  createLearnNotice,
  updateLearnNotice,
  type LearnNoticePayload,
} from '@/api/manage/learnNotice'
import CustomerImg from '@/assets/imgs/Snipaste_2025-07-31_15-17-55.png'
import { useAppStore } from '@/store/modules/app.ts'
import { useUserStore } from '@/store/modules/user'
import { getDeptList } from '@/api/login'
import {
  updateDept,
  getNoticePage,
  noticeReadAll,
  getUnreadCount,
} from '@/api/navBar'
import { changeTextSizeFn, changeColorFn } from '@/libs/utils/theme-fn'
import { useWebSocketStore } from '@/store/modules/websocket'
import { custFormatDate } from '@/libs/utils/data-jsFn'
import { Picture as IconPicture } from '@element-plus/icons-vue'
const isIpad = window.isIpad
const isMaxIpad = window.isMaxIpad
const moreToolsVisible = ref(false)
const moreToolsPanelRef = ref<HTMLElement>()
const moreToolsTriggerRef = ref<HTMLElement>()
const closeMoreToolsOnOutsideClick = (event: MouseEvent) => {
  const target = event.target as Node
  if (
    moreToolsPanelRef.value?.contains(target) ||
    moreToolsTriggerRef.value?.contains(target)
  ) {
    return
  }
  moreToolsVisible.value = false
}
watch(isIpad, value => {
  if (!value) moreToolsVisible.value = false
})
onMounted(() => {
  document.addEventListener('click', closeMoreToolsOnOutsideClick)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', closeMoreToolsOnOutsideClick)
})
const wsStore = useWebSocketStore()
watch(
  () => wsStore.data,
  newData => {
    if (newData == 'pong') return
    console.log('消息通知收到消息', wsStore.data)
    let obj = JSON.parse(wsStore.data) ?? {}
    if (obj.type == 'notice-push') {
      initUnreadCount()
    }
  }
)
const appStore = useAppStore()
const userStore = useUserStore()
const router = useRouter()
const pharmacy = ref(userStore.deptId ?? '')
const messageList = ref([])
const options = ref([])
const theme = computed(() => appStore.theme)
const themeOptions = [
  { label: '蓝色主题', value: 'blue', preview: '#4d8bff' },
  { label: '绿色主题', value: 'green', preview: '#28be9b' },
  { label: '紫色主题', value: 'purple', preview: '#8d69d4' },
  { label: '黄色主题', value: 'yellow', preview: '#ffb43c' },
  { label: '棕色主题', value: 'brown', preview: '#b18056' },
]
const fontSizeOptions = [
  { label: '标准', value: 'default', previewSize: '14px' },
  { label: '中', value: 'middle', previewSize: '16px' },
  { label: '大', value: 'large', previewSize: '18px' },
]
const checkAllFn = async () => {
  msgCount.value = 0
  noticeReadAll()
}
const pharmacyName = computed(() => {
  return options.value.find(e => e.id == userStore.deptId)?.name ?? ''
})
const guwenInfo = computed(() => {
  return userStore.consultantInfo ?? {}
})
onBeforeMount(async () => {
  initDept()
  initMsgList()
  initUnreadCount()
})
const initDept = async () => {
  const res = await getDeptList()
  if (res.code == 0) {
    options.value = res.data ?? []
  }
}
const initMsgList = async () => {
  const res = await getNoticePage({ pageNo: 1, pageSize: 10 })
  if (res.code == 0) {
    messageList.value = res.data.list ?? []
  }
}
const popoverMsgRef = ref()
const jumpMsgDetail = message => {
  router.push(`/msgDetail?id=${message.id}`)
  popoverMsgRef.value?.handleCloseFn()
  if (msgCount.value > 0) {
    msgCount.value = msgCount.value - 1
  }
}
const selectChangeFn = async val => {
  const wsStore = useWebSocketStore()
  wsStore.disconnect()
  const loading = ElLoading.service({
    lock: true,
    text: '门店切换中请稍后...',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  try {
    await updateDept({ deptId: val })
    userStore.setDept(val)
    router.replace('/').then(() => {
      setTimeout(() => {
        window.location.reload(true)
      }, 100)
    })
  } catch (error) {
    pharmacy.value = userStore.deptId ?? ''
    loading.close()
  }
}
// const wsStore = useWebSocketStore()
// watch(
//   () => wsStore.data,
//   newData => {
//     if (newData == 'pong') return
//     console.log('收到推送消息', wsStore.data)
//     let obj = JSON.parse(wsStore.data) ?? {}
//     if (obj.type == 1000 || obj.type == 1001 || obj.type == 2000) {
//       // if (obj.content == userStore.getUserInfo.id) {
//       initDeptList()
//       // }
//     }
//   }
// )
const msgCount = ref(0)
const initUnreadCount = async () => {
  const res = await getUnreadCount()
  if (res.code == 0) {
    msgCount.value = res.data ?? 0
  }
}

// 学习公示
const learnNoticeContent = ref('')
const learnNoticeId = ref<number | null>(null)
const learnNoticeStartTime = ref('')
const learnNoticeEndTime = ref('')
const learnNoticeSyncPatient = ref(false)
const learnNoticeAdvanceDays = ref(3)
const saving = ref(false)
const learnNoticeEditorRef = ref()
const learnNoticeAdvanceDayOptions = Array.from(
  { length: 10 },
  (_, index) => index + 1
)

const padDatePart = (value: number) => `${value}`.padStart(2, '0')
const formatDateValue = (date: Date) => {
  return `${date.getFullYear()}-${padDatePart(
    date.getMonth() + 1
  )}-${padDatePart(date.getDate())}`
}
const formatDateText = (value?: string) => {
  if (!value) return ''
  const [year, month, day] = value.split('-')
  if (!year || !month || !day) return value
  return `${year}年${Number(month)}月${Number(day)}日`
}
const addDays = (value: string, days: number) => {
  const baseDate = value ? new Date(`${value}T00:00:00`) : new Date()
  baseDate.setDate(baseDate.getDate() + days)
  return formatDateValue(baseDate)
}
const getTodayDateValue = () => formatDateValue(new Date())
const getDefaultLearnNoticeStartTime = () => getTodayDateValue()
const normalizeAdvanceDays = (value: unknown, fallback = 3) => {
  const days = Number(value)
  if (!Number.isFinite(days)) return fallback
  return Math.min(10, Math.max(1, Math.trunc(days)))
}
const getInclusiveDateDiff = (startTime?: string, endTime?: string) => {
  if (!startTime || !endTime) return 0
  const startDate = new Date(`${startTime}T00:00:00`)
  const endDate = new Date(`${endTime}T00:00:00`)
  const diff = endDate.getTime() - startDate.getTime()
  if (Number.isNaN(diff) || diff < 0) return 0
  return Math.floor(diff / 86400000) + 1
}
const getNoticeAdvanceDays = (notice: Record<string, any>) => {
  const savedDays = notice.advanceDay
  const dateDiff = getInclusiveDateDiff(notice.startTime, notice.endTime)
  return normalizeAdvanceDays(savedDays ?? dateDiff, 3)
}
const isBeforeToday = (value?: string) => {
  if (!value) return false
  return value < getTodayDateValue()
}
const syncLearnNoticeEndTime = () => {
  if (!learnNoticeStartTime.value) {
    learnNoticeEndTime.value = ''
    return
  }
  learnNoticeEndTime.value = addDays(
    learnNoticeStartTime.value,
    learnNoticeAdvanceDays.value - 1
  )
}
const resetLearnNoticeForm = () => {
  learnNoticeId.value = null
  learnNoticeContent.value = ''
  learnNoticeAdvanceDays.value = 3
  learnNoticeStartTime.value = getDefaultLearnNoticeStartTime()
  syncLearnNoticeEndTime()
  learnNoticeSyncPatient.value = false
}
const normalizeSyncPatient = (value: unknown) => {
  return value === true || value === 1 || value === '1'
}
const getLearnNoticePrintContent = () => {
  const dateRangeText =
    learnNoticeStartTime.value && learnNoticeEndTime.value
      ? `<div style="margin-top: 32px; text-align: center; font-size: 28px; font-weight: 500;">${formatDateText(
          learnNoticeStartTime.value
        )}-${formatDateText(learnNoticeEndTime.value)}</div>`
      : ''
  return `${learnNoticeContent.value}${dateRangeText}`
}
const handleLearnNoticeStartTimeChange = value => {
  if (!value) {
    learnNoticeStartTime.value = getDefaultLearnNoticeStartTime()
  }
  syncLearnNoticeEndTime()
}
const handleLearnNoticeAdvanceDaysChange = value => {
  learnNoticeAdvanceDays.value = normalizeAdvanceDays(value)
  syncLearnNoticeEndTime()
}

const initLearnNotice = async () => {
  resetLearnNoticeForm()
  const res = await getLearnNotice()
  if (res.code == 0 && res.data) {
    learnNoticeId.value = res.data.id
    learnNoticeContent.value = res.data.content ?? ''
    learnNoticeAdvanceDays.value = getNoticeAdvanceDays(res.data)
    const isExpired = isBeforeToday(res.data.endTime)
    if (isExpired) {
      learnNoticeStartTime.value = getDefaultLearnNoticeStartTime()
      syncLearnNoticeEndTime()
      learnNoticeSyncPatient.value = false
    } else {
      learnNoticeStartTime.value =
        res.data.startTime ?? getDefaultLearnNoticeStartTime()
      learnNoticeEndTime.value =
        res.data.endTime ??
        addDays(learnNoticeStartTime.value, learnNoticeAdvanceDays.value - 1)
      learnNoticeSyncPatient.value = normalizeSyncPatient(
        res.data.isSyncPatient
      )
      if (!learnNoticeStartTime.value) {
        learnNoticeStartTime.value = getDefaultLearnNoticeStartTime()
      }
    }
  }
  await nextTick()
  const editor = await learnNoticeEditorRef.value?.getEditorRef()
  if (editor) {
    editor.focus(true)
  }
}

const saveLearnNotice = async () => {
  saving.value = true
  try {
    if (!learnNoticeStartTime.value) {
      learnNoticeStartTime.value = getDefaultLearnNoticeStartTime()
    }
    const data: LearnNoticePayload = {
      content: learnNoticeContent.value,
      deptId: userStore.deptId,
      startTime: learnNoticeStartTime.value,
      endTime: learnNoticeEndTime.value,
      advanceDay: learnNoticeAdvanceDays.value,
      isSyncPatient: learnNoticeSyncPatient.value,
    }
    if (learnNoticeId.value) {
      data.id = learnNoticeId.value
      await updateLearnNotice(data)
    } else {
      const res = await createLearnNotice(data)
      if (res.code == 0) learnNoticeId.value = res.data
    }
    ElMessage.success('保存成功')
  } finally {
    saving.value = false
  }
}

const printLearnNotice = () => {
  const printWindow = window.open('', '_blank')
  if (!printWindow) return
  printWindow.document.write(
    `<!DOCTYPE html><html><head><meta charset="utf-8"><title>学习公示</title><style>@page{size:A4;margin:20mm}body{font-family:sans-serif}</style></head><body>${getLearnNoticePrintContent()}</body></html>`
  )
  printWindow.document.close()
  printWindow.onafterprint = () => printWindow.close()
  printWindow.print()
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: var(--bgc);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    margin-left: 10px;
    cursor: pointer;
    :deep(.el-select .el-select__wrapper) {
      box-shadow: none;
    }
    :deep(.el-select .el-select__wrapper):hover {
      box-shadow: none;
    }
  }

  .right-menu {
    height: 100%;
    line-height: 50px;
    display: flex;
    .right-menu-btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 6px;
        margin-right: 31px;
      }
    }
  }
  .pointer {
    cursor: pointer;
    margin-left: 5px;
    display: flex;
    align-items: center;
    .icon-play {
      font-size: var(--font-size-large);
    }
  }
}
.navbar.is-ipad {
  overflow: visible;
}
.responsive-tools {
  display: flex;
  align-items: center;
}
.responsive-tools.is-ipad {
  position: absolute;
  top: 48px;
  right: 0;
  z-index: 2000;
  width: 132px;
  padding: 6px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: stretch;
  background: var(--bgc);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.14);

  :deep(.pointer) {
    height: 36px;
    margin: 0;
    padding: 0 10px;
    border-radius: 6px;
    line-height: 36px;

    &:hover {
      background: var(--defalut-bgc);
    }

    span {
      margin-left: 8px;
      margin-right: 0;
    }
  }
}
.more-tools-trigger {
  gap: 4px;

  span {
    margin-right: 0 !important;
  }

  .more-tools-arrow {
    margin-right: 31px;
    font-size: 14px;
  }
}
.appearance-panel {
  margin: -12px;
  color: #1f2329;
  line-height: 1.4;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.appearance-panel-header {
  min-height: 56px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf0f3;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
}
.current-theme-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--brown);
  box-shadow: 0 0 0 5px rgba(var(--primary-rgb), 0.08);
}
.theme-options {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 7px;
  padding: 22px;
}
.theme-option {
  position: relative;
  height: 66px;
  padding: 0;
  border: 1px solid rgba(31, 35, 41, 0.06);
  border-radius: 9px;
  outline: none;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    border-color 0.18s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 16px rgba(31, 35, 41, 0.13);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.2);
  }

  &.is-active {
    border-color: var(--brown);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.16);
  }
}
.theme-check {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 22px;
  height: 22px;
  color: #fff;
  font-size: 14px;
  border-radius: 50%;
  background: var(--brown);
  box-shadow: 0 2px 6px rgba(31, 35, 41, 0.2);
}
.font-panel-hint {
  color: #8a9099;
  font-size: 12px;
  font-weight: 400;
}
.font-size-options {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  padding: 18px 20px 20px;
}
.font-size-option {
  min-width: 0;
  height: 66px;
  padding: 10px 8px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #4e5969;
  background: #f6f7f9;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    color: var(--brown);
    border-color: rgba(var(--primary-rgb), 0.45);
    background: rgba(var(--primary-rgb), 0.05);
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.18);
  }

  &.is-active {
    color: var(--brown);
    border-color: var(--brown);
    background: rgba(var(--primary-rgb), 0.08);
    box-shadow: 0 0 0 1px rgba(var(--primary-rgb), 0.08);
  }
}
.font-size-preview {
  height: 30px;
  display: flex;
  align-items: center;
  color: inherit;
  font-weight: 600;
  line-height: 1;
}
.font-size-label {
  font-size: 13px;
  line-height: 18px;
}
.customer-box {
  width: 100%;
  .el-image {
    width: 100%;
    height: 200px;
  }
  .text {
    justify-content: center;
    margin-top: 10px;
  }
  .greeary {
    color: var(--light-text);
  }
  .saoma {
    color: #67c23a;
  }
}
.learn-notice-box {
  width: 100%;
  padding: 4px 0;
  .learn-notice-header {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .learn-notice-form {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }
  .learn-notice-form-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .learn-notice-label {
    white-space: nowrap;
  }
  .learn-notice-days-select {
    width: 120px;
  }
  .learn-notice-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 16px;
  }
}
.message-box {
  width: 100%;
  .header {
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    height: 40px;
    border-bottom: 1px solid var(--border);
  }
  .body {
    max-height: 300px;
    overflow-y: auto;
    padding: 0 10px 10px 10px;
    font-size: var(--font-size-small);
    .body-item {
      width: 100%;
      align-items: center;
      flex-wrap: nowrap;
      padding: 10px 0;
      border-bottom: 1px solid var(--border);
      .item-image {
        width: 37px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 3px;
        .svg-play {
          font-size: 37px;
        }
        .msg-icon-play {
          width: 30px;
          height: 30px;
          border: 1px solid var(--border);
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            color: #df7200;
          }
        }
      }
      .item-content {
        width: calc(100% - 40px);
        .item-title {
          justify-content: space-between;
        }
      }
    }
    .body-item:hover {
      cursor: pointer;
    }
    .is-check {
      color: var(--light-text);
    }
  }
}
</style>
